import { z } from 'zod/v4';

export const AdminDeleteAllowedOriginParamsSchema = z.object({
  id: z.string().min(1),
});

export type AdminDeleteAllowedOriginParams = z.infer<
  typeof AdminDeleteAllowedOriginParamsSchema
>;
